export var DeviceBindingAssessment;
(function (DeviceBindingAssessment) {
    DeviceBindingAssessment["VERIFIED_FOR_USE_ON_THIS_DEVICE"] = "VERIFIED_FOR_USE_ON_THIS_DEVICE";
    DeviceBindingAssessment["PENDING_VERIFICATION_FOR_USE_ON_THIS_DEVICE"] = "PENDING_VERIFICATION_FOR_USE_ON_THIS_DEVICE";
    DeviceBindingAssessment["UNDETERMINED"] = "UNDETERMINED";
    DeviceBindingAssessment["UNBOUND"] = "UNBOUND";
    DeviceBindingAssessment["NOT_APPLICABLE"] = "NOT_APPLICABLE";
})(DeviceBindingAssessment || (DeviceBindingAssessment = {}));
//# sourceMappingURL=DeviceBindingAssessment.js.map